import React, { useEffect, useRef } from "react";
import { LuCircleCheck } from "react-icons/lu";
import { GhostButton } from "../ui";

// Focus lands on the heading rather than the button: the visitor needs to hear that the request
// went through before they are offered a way out of it.
export default function LeadFormSuccess({
  email,
  headingId,
  headingLevel = 2,
  onDone,
  doneLabel,
}: {
  email: string;
  headingId: string;
  headingLevel?: 1 | 2;
  onDone?: () => void;
  doneLabel: string;
}) {
  const headingRef = useRef<HTMLHeadingElement>(null);
  const Heading = headingLevel === 1 ? "h1" : "h2";

  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <div className="tw-mx-auto tw-max-w-xl tw-px-10 tw-py-14 tw-text-center sm:tw-px-6 sm:tw-py-10">
      <span
        aria-hidden
        className="tw-inline-flex tw-h-14 tw-w-14 tw-items-center tw-justify-center tw-rounded-2xl tw-bg-[#e3f7f3] tw-text-[#0f8f7c]"
      >
        <LuCircleCheck className="tw-h-7 tw-w-7" />
      </span>

      <p className="tw-mt-6 tw-mb-0 tw-text-xs tw-font-black tw-uppercase tw-tracking-[.15em] tw-text-[#087bd3]">
        Request received
      </p>

      <Heading
        id={headingId}
        ref={headingRef}
        tabIndex={-1}
        className="tw-mt-4 tw-mb-0 tw-text-3xl tw-font-black tw-leading-tight tw-tracking-[-.04em] tw-text-[#10233f] focus:tw-outline-none sm:tw-text-2xl"
      >
        Thank you.
      </Heading>

      <p className="tw-mt-4 tw-mb-0 tw-text-base tw-leading-7 tw-text-[#536a82]">
        We&apos;ve sent a confirmation to <strong className="tw-text-[#10233f]">{email}</strong>.
        Nothing more to do for now — we&apos;ll go through your answers and come back to you.
      </p>

      {onDone ? (
        <GhostButton type="button" onClick={onDone} className="tw-mt-8">
          {doneLabel}
        </GhostButton>
      ) : null}
    </div>
  );
}
